import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import {
  faEllipsisV,
  faEye,
  faFilter,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Column } from "@tanstack/react-table";
import classNames from "classnames";
import { FC } from "react";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";

const AllCompaniesCoursesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
  onShowFilters,
  notHiddenColumns,
  triggerEnableOrdering,
  smallFilters,
  resetColumnOrder,
  onColumnVisibilityChange: onColumnVisibilityChangeProp,
  activeFiltersCount = 0,
}) => {
  const onColumnVisibilityChange = (column: Column<any, unknown>) => {
    onColumnVisibilityChangeProp?.(column.id, !column.getIsVisible());
    return column.toggleVisibility();
  };

  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Général</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        {!!onShowFilters && (
          <>
            <div className="position-relative">
              <IconButton
                variant="nolina-default"
                size="sm"
                icon={faFilter}
                transform="shrink-4"
                iconAlign="middle"
                onClick={onShowFilters}
                className={classNames({
                  "d-xl-none": !smallFilters,
                })}
              >
                <span
                  className={classNames("ms-1", {
                    "d-none d-sm-inline-block": !smallFilters,
                  })}
                >
                  Filtres
                </span>
              </IconButton>
              {activeFiltersCount > 0 && (
                <Badge
                  bg="danger"
                  pill
                  className="position-absolute"
                  style={{
                    top: "-8px",
                    right: "-8px",
                    fontSize: "0.65rem",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {activeFiltersCount}
                </Badge>
              )}
            </div>
            <div
              className={classNames("bg-300 mx-3", {
                "d-none d-lg-block d-xl-none": !smallFilters,
                "d-none d-lg-block": smallFilters,
              })}
              style={{ width: "1px", height: "29px" }}
            ></div>
          </>
        )}
        <div className="orders-actions">
          <Dropdown
            align="end"
            className="btn-reveal-trigger d-inline-block me-2"
          >
            <Dropdown.Toggle split variant="nolina-default" size="sm">
              <FontAwesomeIcon icon={faEye} className="fs--2" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="border py-0">
              <div className="p-2 pb-0" style={{ minWidth: 250 }}>
                <h6 className="dropdown-header px-0 mb-2">Mes colonnes</h6>
                {notHiddenColumns.map((column) => (
                  <Form.Check
                    key={column.id}
                    type="switch"
                    className="text-dark"
                    label={column.columnDef.header as string}
                    {...{
                      checked: column.getIsVisible(),
                      onChange: () => onColumnVisibilityChange(column),
                    }}
                  />
                ))}
              </div>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
            <Dropdown.Toggle split variant="nolina-default" size="sm">
              <FontAwesomeIcon icon={faEllipsisV} className="fs--2" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="border py-0">
              <div className="py-2">
                <Dropdown.Item onClick={triggerEnableOrdering}>
                  Changer l'ordre des colonnes
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="text-danger"
                  onClick={resetColumnOrder}
                >
                  Réinitialiser l'ordre des colonnes
                </Dropdown.Item>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default AllCompaniesCoursesHeader;
